import { AddressFormFieldNames } from 'shared/enums/addressFormFieldNames';
import { NaturalPersonFormFieldNames } from '../enums/naturalPersonFormFieldNames';
import { PersonalInformationFieldNames } from '../enums/personalInformationFieldNames';
import { NaturalPersonFormValues } from '../types/naturalPersonFormValues';
import { createFormConfig, ValidationRules } from 'helpers/createFormConfig';
import { naturalPersonValidationRules } from './validation-rules/naturalPersonValidationRules';

const naturalPersonFormConfig = createFormConfig<NaturalPersonFormValues>(
  naturalPersonValidationRules as ValidationRules<keyof NaturalPersonFormValues>,
  {
    [PersonalInformationFieldNames.Civility]:
      'Mr',
    [AddressFormFieldNames.Country]: 'FR',
    [PersonalInformationFieldNames.Nationality]: 'FR',
    [PersonalInformationFieldNames.BirthCountry]: 'FR',
    [PersonalInformationFieldNames.Nationality]:
      'FR',
    [NaturalPersonFormFieldNames.TaxResidenceCountryId]: 'FR'
  }
);

const naturalPersonWithInitData = (naturalPersonFormValues:Partial<NaturalPersonFormValues>) =>
  createFormConfig<NaturalPersonFormValues>(
    naturalPersonValidationRules as ValidationRules<keyof NaturalPersonFormValues>,
    naturalPersonFormValues
  );

export { naturalPersonFormConfig, naturalPersonWithInitData };
